import * as React from "react";
import { Component } from "react";
import Facebook from "react-sharingbuttons/dist/buttons/Facebook";
import Twitter from "react-sharingbuttons/dist/buttons/Twitter";
import "react-sharingbuttons/dist/main.css";
import "./ShareButtons.css";
import { ShowStatusBar } from "../components/Layout/GlobalStatusBar";
import { DEFAULT_STATUS_TIMEOUT } from "../constants/SystemConsts";

interface IProps {
    Visible: boolean;
    UrlValue: string;
    OnCloseClick: () => void;
}

export class ShareButtonsComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);

        this.OnCloseClick = this.OnCloseClick.bind(this);
        this.CopyToClipboard = this.CopyToClipboard.bind(this);
    }

    public render() {
        if (this.props.Visible) {
            document.body.classList.add("with-modal");
            return (
                <div className="share-buttons-component">
                    <div className="modal">
                        <div className="modal-main section">
                            <div
                                className="close-btn"
                                onClick={this.OnCloseClick}
                            />
                            <div className="header">
                                <h2>Udostępnij link</h2>
                            </div>
                            <div className="buttons">
                                <Facebook url={this.props.UrlValue} />
                                <Twitter url={this.props.UrlValue} />
                            </div>
                            <div className="url-container">
                                <div className="url-value">
                                    {this.props.UrlValue}
                                </div>
                                <button
                                    className="std-primary-btn-alt"
                                    onClick={this.CopyToClipboard}
                                >
                                    Kopiuj
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    private OnCloseClick(evt) {
        document.body.classList.remove("with-modal");
        this.props.OnCloseClick();
    }

    private CopyToClipboard(evt) {
        const textField = document.createElement("textarea");
        textField.value = this.props.UrlValue;
        textField.style.position = "fixed";
        document.body.appendChild(textField);
        textField.focus();
        textField.select();
        document.execCommand("copy");
        document.body.removeChild(textField);
        ShowStatusBar(
            "Info",
            "Skopiowano adres do schowka",
            DEFAULT_STATUS_TIMEOUT / 2
        );
    }
}



// WEBPACK FOOTER //
// ./src/controls/ShareButtons.tsx